import { clubApi } from '@repo/api-client';
import GoogleMapsPicker from '../ui/google-maps-picker';
import { toast } from 'sonner';
import { useCurrentClub } from '@/hooks/use-current-club';

export function MapPicker() {
  const club = useCurrentClub();
  return (
    <GoogleMapsPicker
      latitude={club.latitude}
      longitude={club.longitude}
      onLocationChange={async (latitude, longitude, address) => {
        await clubApi.update(club.id, {
          latitude: parseFloat(latitude).toFixed(6),
          longitude: parseFloat(longitude).toFixed(6),
          address,
        });
        toast.success('Ubicación actualizada correctamente');
      }}
      apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''}
    />
  );
}
